import cookies from 'js-cookie';
import each from 'lodash/each';
import React from 'react';
import unfetch from 'unfetch';
//import { useStaticQuery, graphql } from 'gatsby';
import { useSetState } from 'react-use';
import { copyToClipboard, getQueryParams, isEmpty } from 'lib/helpers';
import { addToCart, adjustQuantity, getCart, removeFromCart } from 'lib/cart';
//import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

//import { getBreakpoint } from 'lib/helpers';

const AppContext = React.createContext();

export const AppContextProvider = ( { children } ) => {

  const cart = getCart();

  const [ s, setState ] = useSetState( {
    cart: cart,
    cartProcessing: null,
    cartIsShowing: false,
    cartIsProceedingToCheckout: false,
  } );
  s.setState = setState;


  /* ------ = Functions. = --------------------------------------------------------------------- */

  /**
   * Add to cart.
   *
   * @param {func} onAdd Optional.
   * @see lib/cart/addToCart
   */
  s.addToCart = data => {

    setState( {
      cartProcessing: data.productID,
    } );

    addToCart( { ...data } );

    setTimeout( () => {

      const cart = getCart();

      cookies.set( 'cart', JSON.stringify( cart ) );
      const updatedState = {
        cart: getCart(),
        cartIsShowing: true,
      };

      if( ! data.proceedToCheckout ) {
        updatedState.cartProcessing = null;
      }

      setState( updatedState );

      if( data.onAdd ) {
        data.onAdd();
      }

    }, 500 );


  }

  /**
   * remove from cart.
   *
   * @see lib/cart/addToCart
   */
  s.removeFromCart = productID => {

    setState( {
      cartProcessing: productID,
    } );

    removeFromCart( productID );

    setTimeout( () => {

      const cart = getCart();

      setState( {
        cart: cart,
        cartProcessing: null,
      } );

    }, 750 );


  }

  /**
   * Adjust quantity.
   *
   * @see lib/cart/adjustQuantity
   */
  s.adjustQuantity = ( productID, quantity ) => {

    adjustQuantity( productID, quantity );

    setState( {
      cart: getCart()
    } );

  }

  /**
   * Apply coupon.
   *
   * @param {object}  coupon.
   */
  s.applyCoupon = coupon => {

    const cart = getCart();
    const cartCoupons = !! cart.coupons ? cart.coupons : {};
    cartCoupons[`${coupon.id}`] = { ...coupon }
    cart.coupons = cartCoupons;

    //window.localStorage.setItem( 'cart', JSON.stringify( cart ) );
    cookies.set( 'cart', JSON.stringify( cart ) );

    setState( {
      cart: cart,
    } );

  }

  /**
   * Remove coupon.
   *
   * @param {string}  couponID.
   */
  s.removeCoupon = couponID => {

    const cart = getCart();
    const cartCoupons = !! cart.coupons ? cart.coupons : {};
    delete cartCoupons[`${couponID}`];
    cart.coupons = cartCoupons;

    //window.localStorage.setItem( 'cart', JSON.stringify( cart ) );
    cookies.set( 'cart', JSON.stringify( cart ) );

    setState( {
      cart: cart,
    } );

  }

  /**
   * Copy cart URL.
   */
  s.copyCartURL = () => {

    const cart = getCart();
    const queryParams = getQueryParams();
    let newParams = '?';

    if( ! isEmpty( queryParams ) ) {

      each( queryParams, ( value, key ) => {
        newParams = `${newParams}${key}=${value}&`;
      } );

    }
    if( cart ) {
      newParams =  encodeURI( `${newParams}cart=${JSON.stringify( cart )}` );
    }

    const url = `${window.location.href.split( '/?' )[0]}${newParams}`;

    copyToClipboard( url );


  }

  /**
   * Update user data.
   *
   * @param {object} updates.
   * @return {object} updated user.
   */
  s.updateUserData = updates => {

    const userCookie = cookies.get( 'user' );
    const user = !! userCookie ? JSON.parse( userCookie ) : {};
    const updatedUser = { ...user, ...updates };

    cookies.set( 'user', JSON.stringify( updatedUser ) );

    return updatedUser;
    // Update any carts.
    if(
      !! updatedUser.Email &&
      ( updatedUser.Email.includes( '@' ) && updatedUser.Email.includes( '.' ) ) &&
      !! s.cart &&
      typeof window !== 'undefined'
    ) {

      unfetch( `${window.FUNCTIONS_URL}/sf-update-cart`, {
        method: 'POST',
        body: JSON.stringify( {
          action: 'user-update',
          cart: s.cart,
          user: updatedUser
        } )
      } );

    }

    return updatedUser;

  }


  /* ------ = Lifecycle = --------------------------------------------------------------------- */
  //const initBreakpoint = getBreakpoint();


  React.useEffect( () => {


    const queryParams = getQueryParams();
    if( ! queryParams ) {
      return;
    }

    const { gclid, utm_source, lsspecific, adsource } = queryParams;

    // Referral params.
    if( !! gclid ) {
      cookies.set( 'lead_source', gclid );
    }
    if( !! utm_source ) {
      cookies.set( 'lead_source', utm_source );
    }
    if( !! lsspecific ) {
      cookies.set( 'lead_source_specific', lsspecific );
    }
    if( !! adsource ) {
      cookies.set( 'adsource', adsource );
    }



    // Check for cart params.
    if( ! queryParams.cart ) {
      return;
    }

    // Sloppy.
    let cart = queryParams.cart;
    cart = cart
      .replace( /%22/g, '"' )
      .replace( /%20/g, ' ' )
      .replace( /%7B/g, '{' )
      .replace( /%7D/g, '}' );

    cookies.set( 'cart', cart );

    setState( { cart: JSON.parse( cart ) } );

  }, [] );



  /* ------ = Output = --------------------------------------------------------------------- */
  return(
    <AppContext.Provider value={ { ...s, setState  } }>
      { children }
    </AppContext.Provider>
  );

}

export default AppContext;